import React, { useEffect, useState } from "react";
import { CardIcons, getAssignedBonusDetailWithId } from "../../data/wallet";
import { utc2offset } from "../../actions/util";
import moment from "moment";
import promotionErrorConfigModule from "../promotionModalConfigModule";
import { showErrorToast, showSuccessToast } from "../../actions/helper";
import { piwikBonus } from "../../actions/piwikUtil";
import { get } from "../../actions/TlcRequest";
import { ApiPort } from "../../actions/TLCAPI";
import { useDispatch } from "react-redux";
import { promotionActions } from "../../store/promotionSlice";
import AssignedClaimToStartForm from "../Wallet/OWForm/AssignedClaimToStartForm";

function AssinedClaimedBonusCard({ Config, OpenModal, openTnC }) {
    const [loading, setLoading] = useState(false);
    const [assignedClaimToStartFormVisible, setAssignedClaimToStartFormVisible] = useState(false);
    const dispatch = useDispatch();
    let redirectAfterSuccess = () => {
        dispatch(promotionActions.setPromotionSecondLayerTab("2"))
    }
    console.log("AssinedClaimedBonusCard", Config);
    const getPromotionInfo = async () => {
        setLoading(true);
        try {
            if (!Config?.campaignId) {
                return;
            }

            let params = { id: Config.campaignId };

            const res = await getAssignedBonusDetailWithId(params?.id);
            openTnC(res);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    console.log("AssinedClaimedBonusCard", Config);
    return (
        <div className="assigned-claimed-card" style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
        }}>
            <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
            }}
            >
            <div className="card-header">
                <div className="card-title">{Config?.campaignNativeName}</div>
                <div className="card-icons-container">
                    {/* Product Group Icons */}
                    {(Array.isArray(Config?.productGroups) && Config.productGroups?.length === 1) &&
                        Config.productGroups.map((productGroup) => (
                            <CardIcons productGroups={productGroup} />
                        ))}
                </div>
            </div>
            <div className="card-body">
                <div className="promotion-info">
                    <div className="promotion-name">Thưởng trả trước</div>
                    <div className="promotion-amount">{`${Config?.givenAmount} đ`}</div>
                </div>
                <div className="promotion-expiry">
                    <div className="expiry-label">
                        Thời gian kết thúc Khuyến mãi
                    </div>
                    <div className="expiry-date">
                        {utc2offset(
                            Config?.claimEndDateUtc,
                            8,
                            "YYYY/MM/DD HH:mm"
                        )}
                    </div>
                </div>
            </div>
            </div>
            <div className="card-footer">
                <div className="button-container">
                    <div
                        onClick={async () => {
                            piwikBonus.run6();
                            await getPromotionInfo(Config);
                        }}
                        style={{
                            color: "#666666",
                        }}
                        className="left-btn"
                    >
                        Xem chi tiết
                    </div>
                    <div className="divider"></div>
                    <div
                        className="right-btn"
                        onClick={async () => {
                            if (typeof Config?.claimEndDateUtc === "string") {
                                const nowUtc = moment()
                                    .utc()
                                    .format("YYYYMMDDHHmmss");
                                const matchedDate =
                                    Config?.claimEndDateUtc.match(/\d+/g);
                                const isExpired =
                                    matchedDate &&
                                    nowUtc > matchedDate.join("");

                                if (isExpired) {
                                    let configs = {
                                        config: promotionErrorConfigModule?.AssignedClaimExpiryError,
                                    };
                                    OpenModal(configs);
                                    return;
                                }
                            }
                            if (Config?.campaignId) {
                                const res = await get(ApiPort.GETPromotionDetailByCampaignId + Config.campaignId);
                                piwikBonus.run7(res?.promoTitle||'', res?.promoId||'');
                            }
                            setAssignedClaimToStartFormVisible(true);
                            // this.setState({ viewOfWaitingSelectCategoryMdl2025: item }, () => {
                            //     this.PromotionRecordWaitingTrait.displayWaitingSelectCategoryMdl2025(true);
                            // });
                        }}
                    >
                        Nhận khuyến mãi
                    </div>
                </div>
            </div>
            <AssignedClaimToStartForm 
            item={Config} 
            visible={assignedClaimToStartFormVisible}
            handleClose={() => setAssignedClaimToStartFormVisible(false)}
            />
        </div>
    );
}

export default AssinedClaimedBonusCard;
